<template>
    <div class="bg-white rounded-xl overflow-hidden shadow-2xl border border-gray-200 relative aspect-[4/3] transform transition-transform duration-500 hover:scale-[1.02]">
        <!-- Mini App Mockup -->
        <div class="absolute inset-0 flex flex-col">
            <!-- Mini Navbar -->
            <div :style="{ backgroundColor: navbarColor }" class="h-10 flex items-center px-4 justify-between transition-colors duration-500 ease-in-out border-b border-white/10">
                <div class="flex items-center space-x-3">
                    <div class="w-2.5 h-2.5 rounded-full opacity-40" :style="{ backgroundColor: navbarTextColor }"></div>
                    <div class="w-16 h-2 rounded-full opacity-20" :style="{ backgroundColor: navbarTextColor }"></div>
                </div>
                <div class="flex items-center space-x-3">
                    <div class="w-5 h-5 rounded-full opacity-20 border border-white/5" :style="{ backgroundColor: navbarTextColor }"></div>
                    <div class="w-2 h-2 opacity-40 rotate-45" :style="{ backgroundColor: navbarTextColor }"></div>
                </div>
            </div>
            
            <div class="flex flex-1 overflow-hidden">
                <!-- Mini Sidebar -->
                <div :style="{ backgroundColor: sidebarColor }" class="w-20 flex flex-col py-4 transition-colors duration-500 ease-in-out border-r border-white/5">
                    <!-- Sidebar Logo -->
                    <div class="px-2 mb-6">
                        <div v-if="logoUrl" class="h-12 w-full flex items-center justify-center overflow-hidden">
                            <img :src="logoUrl" class="max-h-full max-w-full object-contain" alt="Logo Preview" />
                        </div>
                        <div v-else class="h-12 w-full bg-white/10 rounded flex items-center justify-center">
                             <div class="w-6 h-6 bg-white/15 rounded-full"></div>
                        </div>
                    </div>
                    
                    <!-- Sidebar Items -->
                    <div v-for="i in 8" :key="i" class="px-4 py-2 flex items-center space-x-3 opacity-30">
                        <div class="w-4 h-4 rounded-sm shrink-0" :style="{ backgroundColor: sidebarTextColor }"></div>
                        <div class="w-full h-1.5 rounded-full" :style="{ backgroundColor: sidebarTextColor }"></div>
                    </div>
                </div>
                
                <!-- Mini Content -->
                <div class="flex-1 bg-gray-50 p-5 overflow-hidden">
                    <div class="flex items-center justify-between mb-6">
                        <div class="h-5 w-1/3 bg-gray-200 rounded-lg animate-pulse"></div>
                        <div class="h-8 w-24 bg-indigo-50 rounded-lg"></div>
                    </div>
                    
                    <div class="grid grid-cols-2 gap-4 mb-6">
                        <div class="h-16 bg-white rounded-xl shadow-sm border border-gray-100 p-3">
                            <div class="h-2 w-1/2 bg-gray-100 rounded mb-2"></div>
                            <div class="h-3 w-3/4 bg-gray-200 rounded"></div>
                        </div>
                        <div class="h-16 bg-white rounded-xl shadow-sm border border-gray-100 p-3">
                            <div class="h-2 w-1/2 bg-gray-100 rounded mb-2"></div>
                            <div class="h-3 w-1/3 bg-gray-200 rounded"></div>
                        </div>
                    </div>
                    
                    <div class="h-32 bg-white rounded-xl shadow-sm border border-gray-100 p-4 relative overflow-hidden">
                        <div class="h-2 w-1/4 bg-gray-100 rounded mb-4"></div>
                        <div class="space-y-3">
                            <div class="h-2.5 w-full bg-gray-50 rounded"></div>
                            <div class="h-2.5 w-5/6 bg-gray-50 rounded"></div>
                            <div class="h-2.5 w-4/6 bg-gray-50 rounded"></div>
                        </div>
                        <div class="absolute bottom-4 right-4 h-8 w-20 bg-gray-100 rounded-lg"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        navbarColor: {
            type: String,
            default: '#2f3441'
        },
        sidebarColor: {
            type: String,
            default: '#2f3441'
        },
        navbarTextColor: {
            type: String,
            default: '#ffffff'
        },
        sidebarTextColor: {
            type: String,
            default: '#ffffff'
        },
        logoUrl: {
            type: String,
            default: null
        }
    }
}
</script>
